import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';

export const booleanComparisonNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('booleanComparison'),
    controlValues: z.object({
        operation: z.enum([ 'AND', 'OR', 'XOR' ]),
    }),
});

export interface BooleanComparisonNodeCfgSchema extends z.infer<typeof booleanComparisonNodeCfgSchema> {}

export const booleanComparisonNodeCfg = {
    controlSockets: {
        inputs: () => ({}),
        outputs: () => ({}),
    },
    dataSockets: {
        inputs: () => ({
            input1: 'boolean',
            input2: 'boolean',
        }),
        outputs: () => ({
            output: 'boolean',
        }),
    },
} satisfies NodeSocketCfg<BooleanComparisonNodeCfgSchema>;
